import { useFormikContext } from 'formik'
import { useDebounce } from 'react-use'

export const OnValueChange = ({ debounceTime, onChange }) => {
	const { dirty, values } = useFormikContext()

	useDebounce(
		() => {
			onChange({ values, dirty })
		},
		debounceTime,
		[values, dirty]
	)

	return null
}

OnValueChange.defaultProps = {
	debounceTime: 300,
}
